// Automatically generated based off models.kt
@file:OptIn(ExperimentalSerializationApi::class, InternalSerializationApi::class)
@file:Suppress("UnusedImport", "UNCHECKED_CAST")

package com.ilussobsa

import com.lightningkite.*
import com.lightningkite.Length.Companion.miles
import com.lightningkite.lightningdb.*
import com.lightningkite.lightningserver.files.*
import com.lightningkite.serialization.*
import kotlin.jvm.JvmInline
import kotlin.math.roundToInt
import kotlin.time.Duration.Companion.seconds
import kotlinx.datetime.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi
import com.lightningkite.serialization.DataClassPath
import com.lightningkite.serialization.DataClassPathSelf
import com.lightningkite.serialization.SerializableProperty
import kotlin.reflect.*
import kotlinx.serialization.*
import kotlinx.serialization.builtins.*
import kotlinx.serialization.internal.GeneratedSerializer

// Contextual types: kotlinx.datetime.Instant, com.lightningkite.UUID, com.lightningkite.lightningserver.files.ServerFile, kotlinx.datetime.LocalDate
fun prepareAuctionLaneFields() {
    val props: Array<SerializableProperty<AuctionLane, *>> = arrayOf(AuctionLane__id, AuctionLane_scheduledStart, AuctionLane_name, AuctionLane_description, AuctionLane_condition, AuctionLane_active, AuctionLane_runningAuction)
    AuctionLane.serializer().properties { props }
}
val <K> DataClassPath<K, AuctionLane>._id: DataClassPath<K, UUID> get() = this[AuctionLane__id]
val <K> DataClassPath<K, AuctionLane>.scheduledStart: DataClassPath<K, LocalDateTime> get() = this[AuctionLane_scheduledStart]
val <K> DataClassPath<K, AuctionLane>.name: DataClassPath<K, String> get() = this[AuctionLane_name]
val <K> DataClassPath<K, AuctionLane>.description: DataClassPath<K, String> get() = this[AuctionLane_description]
val <K> DataClassPath<K, AuctionLane>.condition: DataClassPath<K, Condition<Vehicle>> get() = this[AuctionLane_condition]
val <K> DataClassPath<K, AuctionLane>.active: DataClassPath<K, Boolean> get() = this[AuctionLane_active]
val <K> DataClassPath<K, AuctionLane>.runningAuction: DataClassPath<K, UUID?> get() = this[AuctionLane_runningAuction]
inline val AuctionLane.Companion.path: DataClassPath<AuctionLane, AuctionLane> get() = path<AuctionLane>()


object AuctionLane__id: SerializableProperty<AuctionLane, UUID> {
    override val name: String by lazy { AuctionLane.serializer().descriptor.getElementName(0) }
    override fun get(receiver: AuctionLane): UUID = receiver._id
    override fun setCopy(receiver: AuctionLane, value: UUID) = receiver.copy(_id = value)
    override val serializer: KSerializer<UUID> by lazy { (AuctionLane.serializer() as GeneratedSerializer<*>).childSerializers()[0] as KSerializer<UUID> }
    override val annotations: List<Annotation> by lazy { AuctionLane.serializer().descriptor.getElementAnnotations(0) }
    override val default: UUID = uuid()
    override val defaultCode: String? = "uuid()" 
}
object AuctionLane_scheduledStart: SerializableProperty<AuctionLane, LocalDateTime> {
    override val name: String by lazy { AuctionLane.serializer().descriptor.getElementName(1) }
    override fun get(receiver: AuctionLane): LocalDateTime = receiver.scheduledStart
    override fun setCopy(receiver: AuctionLane, value: LocalDateTime) = receiver.copy(scheduledStart = value)
    override val serializer: KSerializer<LocalDateTime> by lazy { (AuctionLane.serializer() as GeneratedSerializer<*>).childSerializers()[1] as KSerializer<LocalDateTime> }
    override val annotations: List<Annotation> by lazy { AuctionLane.serializer().descriptor.getElementAnnotations(1) }
    override val default: LocalDateTime = run {
        val now = now().atZone(auctionZone)
        var current = now.date
        while (current.dayOfWeek != DayOfWeek.FRIDAY) {
            current += DatePeriod(days = 1)
        }
        LocalDateTime(current, LocalTime(12, 0, 0))
    }
    override val defaultCode: String? = "run {" 
}
object AuctionLane_name: SerializableProperty<AuctionLane, String> {
    override val name: String by lazy { AuctionLane.serializer().descriptor.getElementName(2) }
    override fun get(receiver: AuctionLane): String = receiver.name
    override fun setCopy(receiver: AuctionLane, value: String) = receiver.copy(name = value)
    override val serializer: KSerializer<String> by lazy { (AuctionLane.serializer() as GeneratedSerializer<*>).childSerializers()[2] as KSerializer<String> }
    override val annotations: List<Annotation> by lazy { AuctionLane.serializer().descriptor.getElementAnnotations(2) }
}
object AuctionLane_description: SerializableProperty<AuctionLane, String> {
    override val name: String by lazy { AuctionLane.serializer().descriptor.getElementName(3) }
    override fun get(receiver: AuctionLane): String = receiver.description
    override fun setCopy(receiver: AuctionLane, value: String) = receiver.copy(description = value)
    override val serializer: KSerializer<String> by lazy { (AuctionLane.serializer() as GeneratedSerializer<*>).childSerializers()[3] as KSerializer<String> }
    override val annotations: List<Annotation> by lazy { AuctionLane.serializer().descriptor.getElementAnnotations(3) }
}
object AuctionLane_condition: SerializableProperty<AuctionLane, Condition<Vehicle>> {
    override val name: String by lazy { AuctionLane.serializer().descriptor.getElementName(4) }
    override fun get(receiver: AuctionLane): Condition<Vehicle> = receiver.condition
    override fun setCopy(receiver: AuctionLane, value: Condition<Vehicle>) = receiver.copy(condition = value)
    override val serializer: KSerializer<Condition<Vehicle>> by lazy { (AuctionLane.serializer() as GeneratedSerializer<*>).childSerializers()[4] as KSerializer<Condition<Vehicle>> }
    override val annotations: List<Annotation> by lazy { AuctionLane.serializer().descriptor.getElementAnnotations(4) }
    override val default: Condition<Vehicle> = Condition.Always
    override val defaultCode: String? = "Condition.Always" 
}
object AuctionLane_active: SerializableProperty<AuctionLane, Boolean> {
    override val name: String by lazy { AuctionLane.serializer().descriptor.getElementName(5) }
    override fun get(receiver: AuctionLane): Boolean = receiver.active
    override fun setCopy(receiver: AuctionLane, value: Boolean) = receiver.copy(active = value)
    override val serializer: KSerializer<Boolean> by lazy { (AuctionLane.serializer() as GeneratedSerializer<*>).childSerializers()[5] as KSerializer<Boolean> }
    override val annotations: List<Annotation> by lazy { AuctionLane.serializer().descriptor.getElementAnnotations(5) }
    override val default: Boolean = true
    override val defaultCode: String? = "true" 
}
object AuctionLane_runningAuction: SerializableProperty<AuctionLane, UUID?> {
    override val name: String by lazy { AuctionLane.serializer().descriptor.getElementName(6) }
    override fun get(receiver: AuctionLane): UUID? = receiver.runningAuction
    override fun setCopy(receiver: AuctionLane, value: UUID?) = receiver.copy(runningAuction = value)
    override val serializer: KSerializer<UUID?> by lazy { (AuctionLane.serializer() as GeneratedSerializer<*>).childSerializers()[6] as KSerializer<UUID?> }
    override val annotations: List<Annotation> by lazy { AuctionLane.serializer().descriptor.getElementAnnotations(6) }
    override val default: UUID? = null
    override val defaultCode: String? = "null" 
}
